import { render, staticRenderFns } from "./Professional.vue?vue&type=template&id=626b65cf"
import script from "./Professional.vue?vue&type=script&lang=js"
export * from "./Professional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports